import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class DidYouMeanModalResult extends Component {
    static propTypes = {
        result: PropTypes.object.isRequired,
        onResultSelected: PropTypes.func.isRequired
    };

    _onResultSelected = () => {
        const {
            result,
            onResultSelected
        } = this.props;

        onResultSelected(result);
    }

    render() {
        const {
            result: {
                search_string: searchString
            }
        } = this.props;

        return (
            <button
                onClick={this._onResultSelected}
            >
                {searchString}
            </button>
        );
    }
}
